export const url = 'https://gd23.ru'